import axios, { AxiosInstance } from "axios";

// const uri: string = "https://suprkid-backend-dev.herokuapp.com/API/V1/";
export const uri: string = "https://propane-abbey-454106-b1.el.r.appspot.com/API/V1";

// export const uri: string = "http://localhost:5500/API/V1";
export const imageKitUrlEndpoint = "https://ik.imagekit.io/suprkidApp"
export const imageKitPublicKey = "public_/x4XFbzzui88HZABsxxdd15+akY="
// export const uri: string = "http://localhost:5500/API/V1";

const axiosinstance = axios.create({
  baseURL: uri,
  withCredentials: false,
  headers: {
    "Content-Type": "application/json",
  },
});

export { axiosinstance as axios };
